import React, {useState} from 'react'
import { Col, Card, Form, Button } from 'react-bootstrap'
import { FaCheckCircle } from 'react-icons/fa';
import { Link, useOutletContext } from 'react-router-dom'
import { ASSET_URL } from './../../constant';
import { ADD_TO_CART } from '../../helpers';
import {  MySpinner } from '../index';

const CardProduct = (props) => {
    const { getCountCart } = useOutletContext();
    const { data } = props;

    const [Qty, setQty] = useState('')
    const [Load, setLoad] = useState(false)

    // use Default Categories Photo
    const mainImage = JSON.parse(data.image)[0].url != "images/default-image-products.jpg" ?
    JSON.parse(data.image)[0].url :
    JSON.parse(data.category.thumbnail)[0].url;

    const addToCart = async (e) => {
        setLoad(true)
        await ADD_TO_CART(e, data.id, Qty)
        .then((res) => {
            setQty('')
            setLoad(false)
            getCountCart()
        })
    }

    const ViewGrid = () => {
        return (
            <Col lg={4} md={6} sm={12} className="p-0">
                {Load && <MySpinner />}
                <Card className="border rounded-0 product-card">
                    {props.data.discount && <div className="discount" data-discount={`-`+props.data.discount+`% OFF`} /> }
                    <Link to={'/products/'+ data.item_no} className="text-dark">
                        <Card.Body className="pb-0">
                            <div className="product-image">
                                <Card.Img variant="top" src={ASSET_URL + mainImage} className="rounded-0" alt="" />
                            </div>
                            <div className="product-detail">
                                <div className="product-name">
                                    <p className="fs-5 m-0 fw-bold text-uppercase">{data.name}</p>
                                    <p className="fs-6 fw-bold text-secondary text-uppercase">{data.brand && data.brand.name}</p>
                                </div>
                                <div className="product-desc" dangerouslySetInnerHTML={{__html: data.description}} />
                                <div className="product-item">
                                    <p className="text-secondary text-uppercase"><span className="fw-bold">MI ITEM #</span> {data.item_no}</p>
                                </div>
                                <div className="product-stock">
                                    <p>
                                        <FaCheckCircle className="fs-5 text-success" />
                                    </p>
                                    <p className="small">
                                        <b>Quote</b> <br />
                                        For Your Price & Availability Stock
                                    </p>
                                </div>
                            </div>
                        </Card.Body>
                    </Link>
                    <div className="product-cart">
                        <span className="fs-5 fw-bold">Qty</span>
                        <Form>
                            <Form.Group className="input-group">
                                <Form.Control type="number"
                                    name="qty"
                                    autoComplete="off"
                                    value={Qty}
                                    onChange={(e) => setQty(e.target.value)}
                                />
                                <Button variant="info" type="button" onClick={(e) => addToCart(e)}>
                                    Add to Quote
                                </Button>
                            </Form.Group>
                        </Form>
                    </div>
                </Card>
            </Col>
        )
    }

    const ViewList = () => {
        return (
            <Col lg={12} className="p-0">
                {Load && <MySpinner />}
                <div className="border rounded-0 product-card list-view">
                        {props.data.discount && <div className="discount" data-discount={`-` + props.data.discount + `% OFF`} />}
                        <div className="product-image">
                            <Card.Img variant="top" src={ASSET_URL + mainImage} className="rounded-0" alt="" />
                        </div>
                        <div className="product-detail">
                            <Link to={'/products/'+ data.item_no} className="text-dark">
                                <div className="product-name">
                                    <p className="fs-5 m-0 fw-bold text-uppercase">{data.name}</p>
                                    <p className="fs-6 fw-bold text-secondary text-uppercase">{data.brand && data.brand.name}</p>
                                </div>
                                <div className="product-desc" dangerouslySetInnerHTML={{__html: data.description}} />
                                <div className="product-item">
                                    <p className="text-secondary text-uppercase"><span className="fw-bold">MI ITEM #</span> {data.item_no}</p>
                                </div>
                            </Link>
                        </div>
                    <div>
                        <div className="product-stock">
                            <p className="small">
                                <b><FaCheckCircle className="fs-5 text-success" /> Quote</b>
                                <br />
                                For Your Price & Availability Stock
                            </p>
                        </div>
                        <div className="product-cart">
                            <span className="fs-5 fw-bold">Qty</span>
                            <Form>
                                <Form.Group className="input-group">
                                    <Form.Control type="number"
                                        name="qty"
                                        autoComplete="off"
                                        value={Qty}
                                        onChange={(e) => setQty(e.target.value)}
                                    />
                                    <Button variant="info" type="button" onClick={(e) => addToCart(e)}>
                                        Add to Quote
                                    </Button>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </div>
            </Col>
        )
    }

    return (
        <>
            {props.list ? ViewList() : ViewGrid()}
        </>
    )
}

export default CardProduct
